const HARVESTOOOR_ABI = [{
  "anonymous": false,
  "inputs": [{
      "indexed": true,
      "internalType": "address",
      "name": "previousOwner",
      "type": "address"
  }, {
      "indexed": true,
      "internalType": "address",
      "name": "newOwner",
      "type": "address"
  }],
  "name": "OwnershipTransferred",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
      "indexed": false,
      "internalType": "address",
      "name": "account",
      "type": "address"
  }],
  "name": "Paused",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
      "indexed": true,
      "internalType": "address",
      "name": "sender",
      "type": "address"
  }, {
      "components": [{
          "internalType": "address",
          "name": "tokenAddress",
          "type": "address"
      }, {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
      }],
      "indexed": false,
      "internalType": "struct Harvestooor.NFT[]",
      "name": "tokens",
      "type": "tuple[]"
  }],
  "name": "TokensHarvested",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
      "indexed": true,
      "internalType": "address",
      "name": "sender",
      "type": "address"
  }, {
      "components": [{
          "internalType": "address",
          "name": "tokenAddress",
          "type": "address"
      }, {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
      }],
      "indexed": false,
      "internalType": "struct Harvestooor.NFT[]",
      "name": "tokens",
      "type": "tuple[]"
  }],
  "name": "TokensRepurchased",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
      "indexed": false,
      "internalType": "address",
      "name": "account",
      "type": "address"
  }],
  "name": "Unpaused",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
      "indexed": true,
      "internalType": "address",
      "name": "sender",
      "type": "address"
  }, {
      "indexed": false,
      "internalType": "uint256",
      "name": "amount",
      "type": "uint256"
  }],
  "name": "ValueReceived",
  "type": "event"
}, {
  "inputs": [],
  "name": "FIXED_NFT_VALUE",
  "outputs": [{
      "internalType": "uint256",
      "name": "",
      "type": "uint256"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "deposit",
  "outputs": [],
  "stateMutability": "payable",
  "type": "function"
}, {
  "inputs": [{
      "internalType": "address",
      "name": "tokenAddress",
      "type": "address"
  }, {
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "getPriorOwnerByToken",
  "outputs": [{
      "internalType": "address",
      "name": "",
      "type": "address"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [{
      "internalType": "address",
      "name": "",
      "type": "address"
  }, {
      "internalType": "address",
      "name": "from",
      "type": "address"
  }, {
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }, {
      "internalType": "bytes",
      "name": "",
      "type": "bytes"
  }],
  "name": "onERC721Received",
  "outputs": [{
      "internalType": "bytes4",
      "name": "",
      "type": "bytes4"
  }],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [],
  "name": "owner",
  "outputs": [{
      "internalType": "address",
      "name": "",
      "type": "address"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "pause",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [],
  "name": "paused",
  "outputs": [{
      "internalType": "bool",
      "name": "",
      "type": "bool"
  }],
  "stateMutability": "view",
  "type": "function"
}, {
  "inputs": [],
  "name": "renounceOwnership",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
      "components": [{
          "internalType": "address",
          "name": "tokenAddress",
          "type": "address"
      }, {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
      }],
      "internalType": "struct Harvestooor.NFT[]",
      "name": "tokens",
      "type": "tuple[]"
  }],
  "name": "repurchaseTokens",
  "outputs": [],
  "stateMutability": "payable",
  "type": "function"
}, {
  "inputs": [{
      "components": [{
          "internalType": "address",
          "name": "tokenAddress",
          "type": "address"
      }, {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
      }],
      "internalType": "struct Harvestooor.NFT[]",
      "name": "tokens",
      "type": "tuple[]"
  }],
  "name": "sellTokens",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
      "internalType": "address",
      "name": "newOwner",
      "type": "address"
  }],
  "name": "transferOwnership",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [],
  "name": "unpause",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [{
      "internalType": "address payable",
      "name": "recipient",
      "type": "address"
  }, {
      "internalType": "uint256",
      "name": "amount",
      "type": "uint256"
  }],
  "name": "withdraw",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}];

const ERC721_ABI = [{
  "constant": false,
  "inputs": [{
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "approve",
  "outputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "constant": false,
  "inputs": [{
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "mint",
  "outputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "constant": false,
  "inputs": [{
      "internalType": "address",
      "name": "from",
      "type": "address"
  }, {
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "safeTransferFrom",
  "outputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "constant": false,
  "inputs": [{
      "internalType": "address",
      "name": "from",
      "type": "address"
  }, {
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }, {
      "internalType": "bytes",
      "name": "_data",
      "type": "bytes"
  }],
  "name": "safeTransferFrom",
  "outputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "constant": false,
  "inputs": [{
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "internalType": "bool",
      "name": "approved",
      "type": "bool"
  }],
  "name": "setApprovalForAll",
  "outputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "constant": false,
  "inputs": [{
      "internalType": "address",
      "name": "from",
      "type": "address"
  }, {
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "transferFrom",
  "outputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "function"
}, {
  "inputs": [],
  "payable": false,
  "stateMutability": "nonpayable",
  "type": "constructor"
}, {
  "anonymous": false,
  "inputs": [{
      "indexed": true,
      "internalType": "address",
      "name": "from",
      "type": "address"
  }, {
      "indexed": true,
      "internalType": "address",
      "name": "to",
      "type": "address"
  }, {
      "indexed": true,
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "Transfer",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
      "indexed": true,
      "internalType": "address",
      "name": "owner",
      "type": "address"
  }, {
      "indexed": true,
      "internalType": "address",
      "name": "approved",
      "type": "address"
  }, {
      "indexed": true,
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "Approval",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{
      "indexed": true,
      "internalType": "address",
      "name": "owner",
      "type": "address"
  }, {
      "indexed": true,
      "internalType": "address",
      "name": "operator",
      "type": "address"
  }, {
      "indexed": false,
      "internalType": "bool",
      "name": "approved",
      "type": "bool"
  }],
  "name": "ApprovalForAll",
  "type": "event"
}, {
  "constant": true,
  "inputs": [{
      "internalType": "address",
      "name": "owner",
      "type": "address"
  }],
  "name": "balanceOf",
  "outputs": [{
      "internalType": "uint256",
      "name": "",
      "type": "uint256"
  }],
  "payable": false,
  "stateMutability": "view",
  "type": "function"
}, {
  "constant": true,
  "inputs": [{
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "getApproved",
  "outputs": [{
      "internalType": "address",
      "name": "",
      "type": "address"
  }],
  "payable": false,
  "stateMutability": "view",
  "type": "function"
}, {
  "constant": true,
  "inputs": [{
      "internalType": "address",
      "name": "owner",
      "type": "address"
  }, {
      "internalType": "address",
      "name": "operator",
      "type": "address"
  }],
  "name": "isApprovedForAll",
  "outputs": [{
      "internalType": "bool",
      "name": "",
      "type": "bool"
  }],
  "payable": false,
  "stateMutability": "view",
  "type": "function"
}, {
  "constant": true,
  "inputs": [{
      "internalType": "uint256",
      "name": "tokenId",
      "type": "uint256"
  }],
  "name": "ownerOf",
  "outputs": [{
      "internalType": "address",
      "name": "",
      "type": "address"
  }],
  "payable": false,
  "stateMutability": "view",
  "type": "function"
}, {
  "constant": true,
  "inputs": [{
      "internalType": "bytes4",
      "name": "interfaceId",
      "type": "bytes4"
  }],
  "name": "supportsInterface",
  "outputs": [{
      "internalType": "bool",
      "name": "",
      "type": "bool"
  }],
  "payable": false,
  "stateMutability": "view",
  "type": "function"
}];

// Mainnet DAI, Optimism and Arbitrium Rollup Contracts with local addresses
module.exports = {
  HARVESTOOOR_ABI,
  ERC721_ABI,
};
